function socialMediaIntegrationUserExpiryDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/social-media-integration-user-expiry/social-media-integration-user-expiry.html?$$REVISION$$'
  }
}

export { socialMediaIntegrationUserExpiryDialog }
